/* eslint-disable no-underscore-dangle */

/**
 * Main application management
 */
import "./style.css";
import MDBox from "components/Basics/MDBox";
import DashboardLayout from "components/Advanced/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Advanced/Navbars/DashboardNavbar";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ChartsActions from "redux-react/actions/chartsActions";
import lod_ from "lodash";
import {
	Badge,
	Card,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Icon,
	IconButton,
	Menu,
	MenuItem,
	Tooltip
} from "@mui/material";
import { JSONTree } from "react-json-tree";

import axios from "axios";
import i18n from "i18n";
import { useMaterialUIController } from "context";

import ChartsLoader from "components/Custom/ChartsLoader";
import { parseFilters, getLocalStorageBackValues } from "components/Custom/Filters/filters";
import DefaultDataTable from "components/Custom/Tables/DefaultDataTable";
import MDButton from "components/Basics/MDButton";
import { display } from "redux-react/reducers/snackBarReducer";
import MDTypography from "components/Basics/MDTypography";
import OperationActions from "redux-react/actions/operationActions";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import FormActions from "redux-react/actions/formAction";
import FormDictionaryDialog from "components/Custom/FormDictionary";

const ButtonNewLabel = ({ handleClick, namePage }) => {
	return (
		<MDButton
			style={{ height: "100%", marginRight: "0.75rem" }}
			variant="contained"
			color="info"
			onClick={handleClick}
			disabled
		>
			<Icon>add</Icon>&nbsp;{i18n.t("FORMS.LABELS.add") + namePage}
		</MDButton>
	);
};

/**
 *
 * @param {Object} route
 *  - key : actual page
 *  - type : type of page
 *  - icon : icon to display in navbar
 *  - route : actual route
 * @returns
 */
export default function MessagesPage({ route }) {
	const dispatch = useDispatch();

	const { filters } = useSelector(state => state);
	const [controller] = useMaterialUIController();
	const { darkMode } = controller;
	// Loader while charts are loading
	const [chartsLoading, setChartsLoading] = useState(false);
	// Raw charts from collection "analytics" in DB
	const [rawCharts, setRawCharts] = useState({});
	// Raw charts builded from the back
	const [chartsData, setChartsData] = useState({});
	// Default assistant filters
	const [pageFilters, setPageFilters] = useState([]);
	const [openPannel, setOpenPannel] = useState(false);
	const [selectedComponent, setSelectedComponent] = useState({});
	const [selectedJSON, setSelectedJSON] = useState({});

	const rightPannelContainer = useRef(null);
	const [reloadTable, setReloadTable] = useState(false);
	const [attributeMyCode, setAttributeMyCode] = useState([]);

	const [confirmDelete, setConfirmDelete] = useState(false);

	const [addNewLabel, setAddNewLabel] = useState(false);
	const [valuesForm, setValuesForm] = useState({});
	const [formBuild, setFormBuild] = useState({});
	const [contextDictionary, setContextDictionary] = useState({});
	const [PI, setPI] = useState(false);
	const [empty, setEmpty] = useState(false);
	const [listAPIs, setlistAPIs] = useState([]);
	const [useLegacy, setUseLegacy] = useState(false);
	const [dbName, setDbName] = useState(null);
	const [selectedTarget, setSelectedTarget] = useState("");
	const [routeDict, setRouteDict] = useState("");
	const [selectedId, setSelectedId] = useState(null);
	/**
	 * Get charts data to be displayed in front
	 */
	function getChartsData() {
		return chartsData[route.route] ?? [];
	}
	/**
	 * FIRST STEP : Get raw charts from DB
	 */
	function getRawChartsFromDatabase() {
		const onSuccess = res => {
			console.log(res);
			setPageFilters(res.filters);
			setRawCharts({ ...rawCharts, [route.route]: res.charts });
		};
		dispatch(ChartsActions.getCharts(route, onSuccess));
	}
	/**
	 * SECOND STEP : Build charts with the raw charts on the back
	 */
	function buildRawCharts() {
		// Success handler : set charts data
		const onSuccess = res => {
			setChartsData({ ...chartsData, [route.route]: res.charts });
			setChartsLoading(false);
		};
		// Build charts
		if (!rawCharts[route.route]) return;
		let mandatoryFilters = pageFilters.map(filter => filter.attribute);
		let actualFilters = getLocalStorageBackValues(route.route, filters);
		dispatch(
			ChartsActions.buildRawCharts(
				rawCharts[route.route],
				actualFilters,
				mandatoryFilters,
				onSuccess
			)
		);
	}
	/**
	 * FIRST STEP : Get raw charts :
	 * - On mount / when page change
	 * - On selected assistant change
	 */
	useEffect(() => {
		// if (!chartsData[page]) {
		setChartsLoading(true);
		getRawChartsFromDatabase();
		setOpenPannel(false);
		// }
	}, [route]);
	/**
	 * SECOND STEP : Build charts :
	 * - On filters change
	 * - On rawCharts change
	 */
	useEffect(() => {
		buildRawCharts();
	}, [filters, rawCharts]);
	/**
	 * Load filters on mount
	 */

	const actionViewHandle = (item, collection) => {
		setOpenPannel(true);
		setSelectedComponent(item);
		// if scroll in page is above rightPannelContainer ref, scroll to it
		setTimeout(() => {
			let scrollPosition = document.documentElement.scrollTop;
			let pannelTopPosiiton = rightPannelContainer.current.offsetTop;

			if (scrollPosition < pannelTopPosiiton) {
				rightPannelContainer.current.scrollIntoView({
					behavior: "smooth",
					block: "start"
				});
			}
		}, 200);

		const onSuccess = res => {
			setSelectedJSON(res.message);
		};
		dispatch(OperationActions.getMessageByID({ message: item, collection }, onSuccess));
	};

	const actionCheckHandle = (item, event, target) => {
		let copyAttributeMyCode = lod_.cloneDeep(attributeMyCode);

		if (event.target.checked) {
			copyAttributeMyCode.push({ _id: item._id, target, mID: item["data.header.mID"] });
		} else {
			copyAttributeMyCode = lod_.without(
				copyAttributeMyCode,
				lod_.find(copyAttributeMyCode, obj =>
					lod_.isEqual(obj, { _id: item._id, target, mID: item["data.header.mID"] })
				)
			);
		}
		setAttributeMyCode(copyAttributeMyCode);
	};

	const closePannel = () => {
		setOpenPannel(false);
		setSelectedComponent({});
	};

	const handleMenuClick = event => {
		const onSuccess = res => {
			dispatch(
				display({
					message: i18n.t("OPERATION.ACTION.replayMessage"),
					type: "success"
				})
			);
			setReloadTable(!reloadTable);
			setAttributeMyCode([]);
		};
		dispatch(OperationActions.replayMessages(attributeMyCode, onSuccess));
	};

	const deleteItem = event => {
		const onSuccess = res => {
			dispatch(
				display({
					message: i18n.t("OPERATION.ACTION.deleteMessage"),
					type: "success"
				})
			);
			setReloadTable(!reloadTable);
			setAttributeMyCode([]);
			setConfirmDelete(false);
		};
		let ids = attributeMyCode.map(obj => obj._id);
		dispatch(OperationActions.deleteMessages(ids, attributeMyCode[0].target, onSuccess));
	};

	const handleMenuDelClick = event => {
		setConfirmDelete(true);
	};

	const actionEditHandle = (items, target, useLegacy) => {
		const onSuccess = res => {
			setAddNewLabel(true);
			setEmpty(false);
			setValuesForm(res.valueDictionary);
			setFormBuild(res.formBuilderDictionary);
			setContextDictionary(res.dictionary);
			setPI(true);
			setlistAPIs(res.APIs);
			setSelectedId(items._id);
			setSelectedTarget(target);
			setRouteDict(route.form.routeDictionary);
		};
		dispatch(
			FormActions.getItemByID(
				items._id,
				target,
				route.form.routeDictionary,
				onSuccess,
				useLegacy,
				dbName,
				true,
				route.form.catalog
			)
		);
	};

	const actionSaveOrCreateItem = (values, unique, callback) => {
		const onSuccess = res => {
			dispatch(
				display({
					message: i18n.t("FORMS.addEmpty"),
					type: "success"
				})
			);
			setReloadTable(!reloadTable);
			setAddNewLabel(false);
			callback(true);
		};
		let data = {
			values,
			target: selectedTarget,
			unique,
			useLegacy,
			dbName,
			catalog: route.form.catalog
		};
		if (empty) {
			dispatch(
				FormActions.addItemEmpty(data, onSuccess, err => {
					callback(false);
				})
			);
		} else {
			if (data.target === "platformConfig") {
				data.values.last_update = new Date();
			}
			dispatch(
				FormActions.updateItem(selectedId, data, onSuccess, err => {
					callback(false);
				})
			);
		}
	};

	const copyToClipboard = () => {
		// Convertir l'objet JSON en une chaîne JSON
		const jsonString = JSON.stringify(selectedJSON, null, 2);

		// Créer un élément de texte temporaire
		const tempTextArea = document.createElement("textarea");
		tempTextArea.value = jsonString;

		// Ajouter l'élément à la page
		document.body.appendChild(tempTextArea);

		// Sélectionner le texte dans l'élément
		tempTextArea.select();

		// Copier le texte dans le presse-papiers
		document.execCommand("copy");

		// Supprimer l'élément temporaire
		document.body.removeChild(tempTextArea);
	};

	/**
	 * Charts loader
	 */
	if (chartsLoading) {
		return (
			<DashboardLayout>
				<MDBox py={3}>
					<DashboardNavbar />
					<ChartsLoader darkMode={darkMode} />
				</MDBox>
			</DashboardLayout>
		);
	} else
		/**
		 * Main component
		 */
		return (
			<DashboardLayout>
				<MDBox mb={3}>
					<DashboardNavbar
						filters={[
							<MDBox display="flex" alignItems="center">
								<ButtonNewLabel
									handleClick={() => {}}
									namePage={route?.form?.pageLabel ?? route.name}
								/>

								{attributeMyCode.length !== 0 && (
									<MDBox display="flex" flexDirection="row">
										<MDBox mr={2}>
											<Badge badgeContent={attributeMyCode.length} color="info" mr={3}>
												<MDButton
													style={{ height: "100%", marginRight: "0.75rem" }}
													variant="contained"
													color="info"
													onClick={handleMenuClick}
												>
													REPLAY ALL
												</MDButton>
											</Badge>
										</MDBox>

										<MDBox>
											<Badge badgeContent={attributeMyCode.length} color="info">
												<MDButton
													style={{ height: "100%", marginRight: "0.75rem" }}
													variant="contained"
													color="info"
													onClick={handleMenuDelClick}
												>
													Delete ALL
												</MDButton>
											</Badge>
										</MDBox>
									</MDBox>
								)}

								<MDBox display="flex">
									{parseFilters(route.route, pageFilters, filters, dispatch)}
								</MDBox>
							</MDBox>
						]}
					/>
					{confirmDelete && (
						<Dialog open={confirmDelete} onClose={() => setConfirmDelete(false)}>
							<DialogTitle>Supprimer ces éléments</DialogTitle>
							<DialogContent>
								Êtes-vous sûr de vouloir supprimer {attributeMyCode.length} éléments ?
							</DialogContent>
							<DialogActions>
								<MDButton
									autoFocus
									onClick={() => setConfirmDelete(false)}
									variant="outlined"
									color="info"
								>
									{i18n.t("FORMS.cancel")}
								</MDButton>
								<MDButton onClick={deleteItem} color="info" variant="contained" autoFocus>
									{i18n.t("FORMS.validate")}
								</MDButton>
							</DialogActions>
						</Dialog>
					)}
				</MDBox>

				{/*
				 * Pagined table
				 */}
				{getChartsData()
					.filter(chart => chart.type === "paginedList")
					.map((chart, index) => {
						return (
							<MDBox
								className="pageContentContainer"
								style={{
									display: openPannel ? "flex" : "block"
								}}
							>
								<MDBox
									flex="1"
									style={{
										width: openPannel ? "auto" : "auto"
									}}
								>
									<DefaultDataTable
										reloadTable={reloadTable}
										dictionary={chart.dictionary}
										list={chart}
										pagination={chart.pagination}
										canSearch
										key={index}
										table={chart.data}
										collection={chart.request.collection}
										display={chart.request.attributesDisplay}
										actionViewHandle={items => actionViewHandle(items, chart.request.collection)}
										actionCheckHandle={(items, event) =>
											actionCheckHandle(items, event, chart.request.collection)
										}
										actionEditHandle={items =>
											actionEditHandle(items, chart.request.collection, false)
										}
										attributeMyCode={attributeMyCode}
									/>
								</MDBox>
								{openPannel && (
									<MDBox className="rightPannelContainer" ref={rightPannelContainer}>
										<MDBox className="rightPannel" sx={{ ml: 2 }}>
											<Card sx={{ p: 2, height: "100%" }}>
												<MDBox display="flex" alignItems="center" justifyContent="space-between">
													<MDBox>Message JSON :</MDBox>
													<MDBox>
														<Tooltip placement="top" title="Fermer">
															<IconButton onClick={() => closePannel()}>
																<Icon>close</Icon>
															</IconButton>
														</Tooltip>
													</MDBox>
												</MDBox>

												<MDBox
													style={{
														height: "100%",
														overflowY: " auto"
													}}
												>
													<MDTypography variant="h6">
														{Object.keys(selectedJSON).length !== 0 && (
															<>
																<Tooltip placement="right" title="Copier le JSON">
																	<IconButton onClick={() => copyToClipboard()}>
																		<ContentCopyIcon />
																	</IconButton>
																</Tooltip>
																<JSONTree data={selectedJSON} theme={{ base00: "none" }} />
															</>
														)}
													</MDTypography>
												</MDBox>
											</Card>
										</MDBox>
									</MDBox>
								)}
								{addNewLabel && !lod_.isEmpty(valuesForm) && (
									<FormDictionaryDialog
										open={addNewLabel}
										route={route}
										handleCloseDialog={() => setAddNewLabel(false)}
										handleSave={(values, unique, callback) =>
											actionSaveOrCreateItem(values, unique, callback)
										}
										valuesDictionary={valuesForm}
										formBuildDictionary={formBuild}
										contextDictionary={contextDictionary}
										PIaccess={PI}
										isEmpty={empty}
										target={selectedTarget}
										selectedId={selectedId}
										routeDict={routeDict}
										listAPIs={listAPIs}
										useLegacy={useLegacy}
										dbName={dbName}
									/>
								)}
							</MDBox>
						);
					})}
			</DashboardLayout>
		);
}
